import 'react-international-phone/style.css'

import {
    InputAdornment,
    MenuItem,
    Select,
    TextField,
    Typography,
} from '@mui/material'
import React from 'react'
import {
    defaultCountries,
    FlagImage,
    parseCountry,
    usePhoneInput,
} from 'react-international-phone'

export const PhoneInput = ({ value, onChange, onValidityChange, ...restProps }) => {
    const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } =
        usePhoneInput({
            defaultCountry: 'tr',
            value,
            countries: defaultCountries,
            onChange: (data) => {
                onChange(data.phone)
                if (typeof onValidityChange === 'function') {
                    const hasIsValid = Object.prototype.hasOwnProperty.call(data, 'isValid')
                    if (hasIsValid) {
                        onValidityChange(!!data.isValid)
                    } else {
                        // Fallback heuristic by length: require country code + reasonable national length
                        try {
                            const digits = String(data.phone || '').replace(/\D/g, '')
                            const dial = String(country?.dialCode || '')
                            const minNational = country?.iso2 === 'tr' ? 10 : 7
                            onValidityChange(digits.length >= (dial.length + minNational))
                        } catch (e) {
                            onValidityChange(false)
                        }
                    }
                }
            },
        })

    return (
        <TextField
            variant="outlined"
            label="Phone number"
            color="primary"
            placeholder="Phone number"
            value={inputValue}
            onChange={handlePhoneValueChange}
            type="tel"
            inputRef={inputRef}
            InputProps={{
                startAdornment: (
                    <InputAdornment
                        position="start"
                        style={{ marginRight: '2px', marginLeft: '-8px' }}
                    >
                        <Select
                            MenuProps={{
                                style: {
                                    height: '300px',
                                    width: '360px',
                                    top: '10px',
                                    left: '-34px',
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left',
                                },
                            }}
                            sx={{
                                width: 'max-content',
                                // Remove default outline (display only on focus)
                                fieldset: {
                                    display: 'none',
                                },
                                '&.Mui-focused:has(div[aria-expanded="false"])': {
                                    fieldset: {
                                        display: 'block',
                                    },
                                },
                                // Update default spacing
                                '.MuiSelect-select': {
                                    padding: '8px',
                                    paddingRight: '24px !important',
                                },
                                svg: {
                                    right: 0,
                                },
                            }}
                            value={country.iso2}
                            onChange={(e) => setCountry(e.target.value)}
                            renderValue={(value) => (
                                <FlagImage iso2={value} style={{ display: 'flex' }} />
                            )}
                        >
                            {defaultCountries.map((c) => {
                                const country = parseCountry(c)
                                return (
                                    <MenuItem key={country.iso2} value={country.iso2}>
                                        <FlagImage
                                            iso2={country.iso2}
                                            style={{ marginRight: '8px' }}
                                        />
                                        <Typography marginRight="8px">{country.name}</Typography>
                                        <Typography color="gray">+{country.dialCode}</Typography>
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </InputAdornment>
                ),
            }}
            {...restProps}
        />
    )
}